module.exports = __webpack_public_path__ + "img/home_img_3.f6a0fc56.webp";